import { createRoute, lazyRouteComponent, Outlet } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';
import RequireWarehouse from 'root/RequireWarehouse';

import ProductAverageWeightEnabledRoute from './ProductAverageWeightEnabledRoute';

const productAverageWeightRootRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'product-average-weight-root',
});

const ProductAverageWeightRequireWarehouse = () => {
  return (
    <RequireWarehouse
      routeWithWarehouseId="/product-average-weight/warehouse/$warehouseId"
      routeWithoutWarehouseId="/product-average-weight"
    >
      <Outlet />
    </RequireWarehouse>
  );
};

const requireWarehouseRoute = createRoute({
  getParentRoute: () => productAverageWeightRootRoute,
  path: '/product-average-weight',
  component: ProductAverageWeightRequireWarehouse,
});

const productAverageWeightWarehouseWrapperRoute = createRoute({
  getParentRoute: () => requireWarehouseRoute,
  path: 'warehouse/$warehouseId',
  parseParams: z.object({ warehouseId: z.string().uuid() }).parse,
});

const productAverageWeightEnabledRoute = createRoute({
  getParentRoute: () => productAverageWeightWarehouseWrapperRoute,
  id: 'productAverageWeightEnabledRoute',
  component: ProductAverageWeightEnabledRoute,
});

export const productAverageWeightRoute = createRoute({
  getParentRoute: () => productAverageWeightEnabledRoute,
  path: '/',
  component: lazyRouteComponent(
    () => import('./ProductAverageWeightView/ProductAverageWeightView'),
  ),
  validateSearch: z.object({
    showSearchDrawer: z.coerce.boolean().optional(),
    searchQuery: z.coerce.string().optional(),
  }).parse,
});

export const addProductWeightRoute = createRoute({
  getParentRoute: () => productAverageWeightEnabledRoute,
  path: '/$productId',
  component: lazyRouteComponent(() => import('./AddProductWeightView/AddProductWeightView')),
  parseParams: (params) => ({
    productId: z.string().parse(params.productId),
  }),
  validateSearch: z.object({
    showChangeLogDrawer: z.coerce.boolean().optional(),
    showWarningModal: z.coerce.boolean().optional(),
    from: z.string().optional(),
  }).parse,
});

export const productAverageWeightRouteTree = productAverageWeightRootRoute.addChildren({
  requireWarehouseRoute: requireWarehouseRoute.addChildren({
    productAverageWeightWarehouseWrapperRoute:
      productAverageWeightWarehouseWrapperRoute.addChildren({
        productAverageWeightEnabledRoute: productAverageWeightEnabledRoute.addChildren({
          productAverageWeightRoute,
          addProductWeightRoute,
        }),
      }),
  }),
});
